interface ComparisonTableProps {
  headers: string[];
  rows: string[][];
}

export function ComparisonTable({ headers, rows }: ComparisonTableProps) {
  return (
    <div
      style={{
        margin: "var(--s-md) 0",
        border: "1px solid var(--dyna-border)",
        borderRadius: 12,
        overflow: "hidden",
        background: "var(--dyna-bg-elevated)",
      }}
    >
      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "Geist, system-ui, sans-serif",
            fontSize: 14,
            color: "var(--dyna-fg)",
          }}
        >
          <thead>
            <tr>
              {headers.map((h, i) => (
                <th
                  key={i}
                  scope="col"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "var(--dyna-bg)",
                    textAlign: "start",
                    padding: "12px 16px",
                    fontWeight: 600,
                    fontSize: 12,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--lavender-400)",
                    borderBottom: "1px solid var(--dyna-border)",
                    fontFamily: "'JetBrains Mono', monospace",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr
                key={ri}
                style={{
                  background: ri % 2 === 0 ? "transparent" : "rgba(156,139,194,0.04)",
                }}
              >
                {row.map((cell, ci) => (
                  <td
                    key={ci}
                    style={{
                      padding: "12px 16px",
                      borderTop: ri === 0 ? "none" : "1px solid var(--dyna-border)",
                      verticalAlign: "top",
                    }}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
